import { Data } from 'interfaces/ApolloResponse.interface'

const isSecondDebtor = ({ debtors: { count } }: Data) => count > 1

export default isSecondDebtor
